import { useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { HeaderAnonymous } from './_anonymous/HeaderAnonymous';
import { Header } from './_authenticated/Header';
import { InitGate } from './_authenticated/InitGate';
import { Spinner } from '../components/Spinner';
import { useTokens } from '../hooks/useTokens';
import { ReceptionistsProvider } from '../services/receptionists/ReceptionistsProvider';
import { pageView } from '../utils/tracking';

export const AuthenticatedLayout = () => {
  const location = useLocation();
  useEffect(() => {
    pageView(location.pathname);
  }, [location]);

  const { tokens } = useTokens();

  if (tokens === undefined) {
    return (
      <div className="h-auto">
        <HeaderAnonymous />
        <div className="md:overflow-auto mt-12 md:mt-0 md:ml-48">
          <Spinner />
        </div>
      </div>
    );
  }

  if (tokens === null) {
    return <Navigate to="/login" replace={true} />;
  }

  return (
    <InitGate>
      <ReceptionistsProvider>
        <div className="h-auto min-h-screen">
          <Header />
          <div className="overflow-auto md:mt-0 md:ml-48 content-area">
            <Outlet />
          </div>
        </div>
      </ReceptionistsProvider>
    </InitGate>
  );
};
